import { PerformanceEventName } from '@ms/yammer-telemetry/dist/performance';

import { endAndReportPerformanceMeasure, startPerformanceMeasure } from '../telemetry';

import { acquireToken } from './authenticator';

export class AcquireTokenTimedoutError extends Error {
  public name = 'AcquireTokenTimedoutError';

  constructor(...args: Parameters<ErrorConstructor>) {
    super(...args);
    Object.setPrototypeOf(this, AcquireTokenTimedoutError.prototype);
  }
}

const rejectAfter = (ms: number, error: Error) =>
  new Promise<never>((_resolve, reject) =>
    setTimeout(() => {
      reject(error);
    }, ms)
  );

const acquireTokenWithTimeout: (scopes: string[], timeout: number) => Promise<string> = (scopes, timeout) => {
  const acquireTokenPromise = acquireToken(scopes);
  const timeoutPromise = rejectAfter(timeout, new AcquireTokenTimedoutError());

  return Promise.race([acquireTokenPromise, timeoutPromise]);
};

const acquireTokenWithTelemetry: (scopes: string[], timeout?: number) => Promise<string> = async (scopes, timeout) => {
  let endedWithError = false;
  const measure = startPerformanceMeasure(PerformanceEventName.AcquireTokenForResource);
  try {
    if (timeout) {
      return await acquireTokenWithTimeout(scopes, timeout);
    }

    return await acquireToken(scopes);
  } catch (error) {
    endedWithError = true;
    throw error;
  } finally {
    endAndReportPerformanceMeasure({ ...measure, eventProperties: { endedWithError } });
  }
};

export type AcquireTokenWithRetry = (scopes: string[], timeout?: number) => Promise<string>;
export const acquireTokenWithRetry: AcquireTokenWithRetry = async (scopes, timeout) => {
  try {
    return await acquireTokenWithTelemetry(scopes, timeout);
  } catch {
    return acquireTokenWithTelemetry(scopes, timeout);
  }
};
